import React from 'react';

const UpDateProfile = () => {
    return (
        <div>
            <h1>update profile</h1>
        </div>
    );
};

export default UpDateProfile;